"use client";
import { u as r } from "./useRenderElement-B8V3_e8R.mjs";
function t(n) {
  const e = n;
  return e.disableStyleHooks = !0, r(void 0, e, e);
}
export {
  t as u
};
